import EventBus from '@/components/mixins/event-bus-mixin'

export default {
  name: 'loader',
  inject: [
    '$utils'
  ],
  props: {
    isVisibleProp: {
      type: Boolean,
      default () { return false }
    },
    iconColor: {
      type: String,
      default () { return '#1e84e2' }
    }
  },
  data () {
    return {
      isVisible: this.isVisibleProp,
      videoSrc: '',
      isTwelvEightyResolution: false
    }
  },
  methods: {
    handleCloseButton () {
      this.isVisible = false
      this.videoSrc = ''
      EventBus.$emit('CLOSE_FULL_SCREEN_VIDEO', { isVisible: false })
    },
    handleFullScreenVisibility (videoSrc) {
      const setData = () => {
        // Show error message once video src is empty
        if (!videoSrc) {
          EventBus.$emit('SHOW_CUSTOM_NOTIFICATION', {
            type: 'error',
            alert: {
              message: this.$t('label.noVideoAvailable')
            }
          })
          this.handleCloseButton()
          return
        }

        this.videoSrc = videoSrc
        this.isVisible = true
      }

      $(window).on('resize', () => { setData() })
      setData()
    }
  },
  mounted () {
    // Listen from Global events show full screen video
    EventBus.$on('SHOW_FULL_SCREEN_VIDEO', (payload) => {
      let videoSrcParams = payload.videopreviews ? payload.videopreviews : null
      if (Array.isArray(videoSrcParams) && videoSrcParams.length === 0) videoSrcParams = null

      this.handleFullScreenVisibility(videoSrcParams)
    })

    EventBus.$on('CLOSE_FULL_SCREEN_VIDEO', (payload) => {
      this.isVisible = false
      this.videoSrc = ''
    })
  }
}
